var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpNextArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "up_next_arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "next_arrow",
    d: "M17.6607 0.706832C16.8687 0.0047989 15.6542 0.0732144 14.951 0.866437C14.2466 1.65965 14.3174 2.87288 15.1106 3.57731L19.9756 7.90219H14.4649C6.52413 7.90219 0.0644531 14.3619 0.0644531 22.3026C0.0644531 23.3622 0.924883 24.2227 1.98451 24.2227C3.04413 24.2227 3.90456 23.3622 3.90456 22.3026C3.90456 16.4801 8.64233 11.7423 14.4649 11.7423H19.9756L15.1106 16.0672C14.3174 16.7716 14.2466 17.9848 14.951 18.7781C15.329 19.2041 15.8558 19.4225 16.3851 19.4225C16.8387 19.4225 17.2947 19.2629 17.6595 18.9377L26.2997 11.2575C26.7113 10.8927 26.9454 10.3706 26.9454 9.82222C26.9454 9.27379 26.7114 8.75178 26.3009 8.38697L17.6607 0.706832Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpNextArrow);
export default __webpack_public_path__ + "static/media/up_next_arrow.6c82f153f4b2e515c58638db607cad48.svg";
export { ForwardRef as ReactComponent };